const rangeSlider = document.querySelectorAll('.image-comparison__drag-input');

const showRangeProgress = (parent, value, max) => {
  parent.style.setProperty('--seek-before-width', `${(value / max) * 100}%`);
};

rangeSlider.forEach((dragSlider) => {
  const parentElem = dragSlider.closest('.image-comparison__front');

  dragSlider.addEventListener('input', (e) => {
    showRangeProgress(parentElem, e.target.value, e.target.max);
  });

  dragSlider.addEventListener('pointerup', (e) => {
    if (e.target.value < 100) {
      showRangeProgress(parentElem, 0, e.target.max);
      e.target.value = 0;
    } else {
      parentElem.classList.add('swiped');
    }
  });
});

// ---
// Comparison slider - https://image-compare-viewer.netlify.app/
// ---

const viewers = document.querySelectorAll('.image-comparison__back-init');

const comparisonSliderOption = {
  // UI Theme Defaults

  controlColor: false,
  controlShadow: false,
  addCircle: false,
  addCircleBlur: false,

  // Label Defaults

  showLabels: false,
  labelOptions: {
    before: 'Before',
    after: 'After',
    onHover: false,
  },

  // Smoothing

  smoothing: true,
  smoothingAmount: 200,

  // Other options
  hoverStart: false,
  verticalMode: false,
  startingPoint: 50,
  fluidMode: true,
};

viewers.forEach((element) => {
  const view = new ImageCompare(element, comparisonSliderOption).mount();
});
